<template>
  <div class="popup-wrapper">
    <div class="popup-overlay" @click="closeDialog"></div>
    <div class="popup-container premium-dialog">
      <div class="close-button" @click="closeDialog">
        <i class="el-icon-close"></i>
      </div>
      
      <div class="premium-header">
        <h2>{{ $t('price.upgrade') }}</h2>
        <p class="subtitle">{{ $t('price.improveEfficiency') }} <span>10x</span> !</p>
      </div>
      
      <div class="features-list">
        <div class="feature-item">
          <div class="check-icon">✓</div>
          <div class="feature-text">{{ $t('price.unlimitedLiveRecord') || 'Unlimited Record Live Lecture' }}</div>
        </div>
        <div class="feature-item">
          <div class="check-icon">✓</div>
          <div class="feature-text">{{ $t('price.unlimitedAudioRecord') || 'Unlimited Record Audio & YouTube/Bilibili' }}</div>
        </div>
        <div class="feature-item">
          <div class="check-icon">✓</div>
          <div class="feature-text">{{ $t('price.unlimitedDocuments') || 'Unlimited Documents Upload' }}</div>
        </div>
        <div class="feature-item">
          <div class="check-icon">✓</div>
          <div class="feature-text">{{ $t('price.unlimitedChat') || 'Unlimited Chat Messages' }}</div>
        </div>
        <div class="feature-item">
          <div class="check-icon">✓</div>
          <div class="feature-text">{{ $t('price.unlimitedFlashcards') || 'Unlimited Flashcards &Quiz Questions' }}</div>
        </div>
      </div>
      
      <div class="pricing-options">
        <div class="price-option" :class="{ annual: true, selected: selectedPlan === 'yearly' }" @click="selectPlan('yearly')">
          <div class="option-label">{{ $t('price.yearlyPlan') || 'Annual' }}({{ $t('price.save') || 'Save' }} 60%)</div>
          <div class="price">$ {{ yearlyPrice }} / {{ $t('price.month') || 'Month' }}</div>
          <div class="billing-note">{{ $t('price.billedYearly') || 'billed yearly' }}</div>
        </div>
        
        <div class="price-option" :class="{ monthly: true, selected: selectedPlan === 'monthly' }" @click="selectPlan('monthly')">
          <div class="option-label">{{ $t('price.monthlyPlan') || 'Monthly' }}</div>
          <div class="price">$ {{ monthlyPrice }} / {{ $t('price.month') || 'Month' }}</div>
          <div class="billing-note">{{ $t('price.billedMonthly') || 'billed monthly' }}</div>
        </div>
      </div>
      
      <div class="action-area">
        <button class="upgrade-btn" @click="subscribe">
          {{ $t('price.subscribe') || 'Upgrade Now!' }}
        </button>
      </div>
      
      <div class="terms-section">
        <a href="#">{{ $t('price.termsOfService') || 'Terms of Service' }}</a> | <a href="#">{{ $t('price.privacyPolicy') || 'Privacy Policy' }}</a>
      </div>
    </div>
    
    <!-- 支付方式选择对话框 -->
    <div class="payment-dialog-wrapper" v-if="showPaymentDialog">
      <div class="payment-dialog-overlay" @click="showPaymentDialog = false"></div>
      <div class="payment-dialog">
        <div class="payment-dialog-header">
          <h3>Select Payment Method</h3>
          <div class="close-button" @click="showPaymentDialog = false">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="payment-methods">
          <div class="payment-button wechat" @click="handleWechatPay">
            <span>WeChat Pay</span>
            <img :src="icon_wechatpay" alt="WeChat Pay">
          </div>
          <div class="payment-button credit-card" @click="handleCreditCard">
            <span>Credit Card</span>
            <div class="card-icons">
              <img :src="icon_visa" alt="">
              <img :src="icon_wanshida" alt="">
              <img :src="icon_us_yt" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 微信支付二维码弹窗 -->
    <div class="qrcode-dialog-wrapper" v-if="showQRCodeDialog">
      <div class="qrcode-dialog-overlay" @click="handleQrCodeDialogClose"></div>
      <div class="qrcode-dialog">
        <div class="qrcode-dialog-header">
          <h3>Scan the pay with WeChat</h3>
          <div class="close-button" @click="handleQrCodeDialogClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="qrcode-container">
          <div class="qrcode-img">
            <span class="order-number">Order Number：{{ orderNumber }}</span>
            <div class="qrcode-wrapper" v-loading="isLoading" element-loading-text="Loading..."
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.5)">
              <img v-if="!isLoading" :src="qrCodeUrl" alt="WeChat Pay QR Code">
              <!-- 添加遮罩层 -->
              <div v-if="isQrCodeExpired" class="qrcode-overlay" @click="refreshQRCode">
                <span>
                  <i class="el-icon-refresh"></i>
                  QR Code Expired
                  <br>
                  Click to refresh
                </span>
              </div>
            </div>
            <span>EasyNote AI-{{ currentPlanName }} Plan</span>
            <span v-if="currentPlanName === 'Annual'">
              <span class="price-text">$100</span> <span>Per Year</span>
            </span>
            <span v-else>
              <span class="price-text">$19.99</span> <span>Per Month</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupPrice',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      yearlyPrice: '8.39',
      monthlyPrice: '19.99',
      selectedPlan: 'yearly',
      
      // 支付相关
      showPaymentDialog: false,
      showQRCodeDialog: false,
      
      // 图标资源
      icon_wechatpay: require('@/assets/images/pay/icons8_wechatpay.png'),
      icon_visa: require('@/assets/images/pay/icons8_visa.png'),
      icon_wanshida: require('@/assets/images/pay/icons8_wanshida.png'),
      icon_us_yt: require('@/assets/images/pay/icons8_us_yt.png'),
      
      // 微信支付相关
      qrCodeUrl: '',
      orderNumber: '',
      currentPlanName: '',
      expireTime: 0,
      checkExpireTimer: null,
      statusPollingTimer: null,
      isQrCodeExpired: false,
      isLoading: false
    }
  },
  mounted() {
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    this.clearTimers();
  },
  methods: {
    closeDialog() {
      this.$emit('closePricePopup');
    },
    selectPlan(plan) {
      this.selectedPlan = plan;
    },
    subscribe() {
      this.currentPlanName = this.selectedPlan === 'yearly' ? 'Annual' : 'Monthly';
      
      if (this.selectedPlan === 'yearly') {
        // 年度计划，显示支付方式选择
        this.showPaymentDialog = true;
      } else {
        // 月度计划，直接调用信用卡支付
        this.handleCreditCard();
      }
    },
    async handleWechatPay() {
      this.showPaymentDialog = false;
      this.showQRCodeDialog = true;
      this.isLoading = true;
      
      try {
        const subid = this.$cookies.get("subid");
        const unitamount = this.selectedPlan === 'yearly' ? this.yearlyPrice : this.monthlyPrice;
        const interval = this.selectedPlan === 'yearly' ? 'year' : 'month';
        const payname = this.selectedPlan === 'yearly' ? 'Annual' : 'Monthly';
        
        const response = await this.$axios.post("/api/createalphapaysession/", {
          subid,
          unitamount,
          interval,
          payname,
        });
        
        const { code, qr_image, order_number, expire_time } = response.data;
        
        if (code === 301) {
          this.$message.error("You have already subscribed");
          this.$router.push("/home");
          return;
        }
        
        if (code === 200) {
          this.qrCodeUrl = qr_image;
          this.orderNumber = order_number;
          this.expireTime = expire_time;
          
          // 开始轮询订单状态
          this.startPollingOrderStatus();
          
          // 设置二维码过期检查
          this.clearTimers();
          this.checkExpireTimer = setInterval(() => {
            if (Date.now() / 1000 >= this.expireTime) {
              this.isQrCodeExpired = true;
              this.clearTimers();
            }
          }, 1000);
        } else {
          this.$message.error(response.data.message || "Error creating payment");
        }
      } catch (error) {
        console.error("Error:", error);
        this.$message.error("处理请求时出错，请重试");
      } finally {
        this.isLoading = false;
      }
    },
    
    async refreshQRCode() {
      this.isQrCodeExpired = false;
      this.isLoading = true;
      
      try {
        const response = await this.$axios.post("/api/refresh_qr_code/", {
          order_number: this.orderNumber
        });
        
        const { code, qr_image, order_number, expire_time } = response.data;
        if (code === 200) {
          this.qrCodeUrl = qr_image;
          this.orderNumber = order_number;
          this.expireTime = expire_time;
          
          // 重新开始轮询
          this.startPollingOrderStatus();
          
          // 设置二维码过期检查
          this.clearTimers();
          this.checkExpireTimer = setInterval(() => {
            if (Date.now() / 1000 >= this.expireTime) {
              this.isQrCodeExpired = true;
              this.clearTimers();
            }
          }, 1000);
        } else {
          this.$message.error(response.data.message || "Error refreshing QR code");
        }
      } catch (error) {
        this.isQrCodeExpired = true;
        console.error("Error:", error);
        this.$message.error("刷新二维码失败");
      } finally {
        this.isLoading = false;
      }
    },
    
    startPollingOrderStatus() {
      // 清除之前的轮询
      if (this.statusPollingTimer) {
        clearInterval(this.statusPollingTimer);
      }
      
      // 开始新的轮询
      this.statusPollingTimer = setInterval(async () => {
        try {
          const response = await this.$axios.post("/api/query_order_status/", {
            order_number: this.orderNumber
          });
          
          if (response.data.code === 200) {
            // 支付成功
            this.clearTimers();
            this.showQRCodeDialog = false;
            this.$message.success("支付成功!");
            this.$router.push("/home");
          }
        } catch (error) {
          console.error("Error polling status:", error);
        }
      }, 3000); // 每3秒查询一次
    },
    
    async handleCreditCard() {
      this.showPaymentDialog = false;
      
      try {
        const subid = this.$cookies.get("subid");
        const unitamount = this.selectedPlan === 'yearly' ? this.yearlyPrice : this.monthlyPrice;
        const interval = this.selectedPlan === 'yearly' ? 'year' : 'month';
        const payname = this.selectedPlan === 'yearly' ? 'Annual' : 'Monthly';
        
        const response = await this.$axios.post("/api/createcheckoutsession/", {
          subid,
          unitamount,
          interval,
          payname,
        });
        
        const { url, code } = response.data;
        switch (code) {
          case 200:
            window.location.href = url;
            break;
          case 201:
            this.$message({
              message: "Please log in",
              type: "error",
            });
            this.$router.push("/login");
            break;
          case 301:
            this.$message({
              message: "You have already subscribed",
              type: "success",
            });
            this.$router.push("/home");
            break;
          default:
            this.$message({
              message: "Error creating checkout session",
              type: "error",
            });
        }
      } catch (error) {
        console.error("Error:", error);
        this.$message({
          message: "处理请求时出错，请重试。",
          type: "error",
        });
      }
    },
    
    handleQrCodeDialogClose() {
      this.showQRCodeDialog = false;
      this.handleDialogClose();
    },
    
    handleDialogClose() {
      // 清理所有定时器
      this.clearTimers();
      // 重置相关状态
      this.isQrCodeExpired = false;
      this.isLoading = false;
      this.qrCodeUrl = '';
    },
    
    clearTimers() {
      if (this.checkExpireTimer) {
        clearInterval(this.checkExpireTimer);
        this.checkExpireTimer = null;
      }
      if (this.statusPollingTimer) {
        clearInterval(this.statusPollingTimer);
        this.statusPollingTimer = null;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.popup-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
}

.popup-container {
  position: relative;
  width: 520px;
  max-width: 90vw;
  max-height: 90vh;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 2001;
  animation: popup-animation 0.3s ease-out forwards;
  padding: 30px;
}

@keyframes popup-animation {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  
  i {
    font-size: 16px;
    color: #888;
  }
}

.premium-header {
  text-align: center;
  margin-bottom: 25px;
  
  h2 {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0 0 8px;
  }
  
  .subtitle {
    font-size: 16px;
    margin: 0;
    color: #5065F6;
    
    span {
      font-weight: bold;
      color: #5065F6;
    }
  }
}

.features-list {
  display: table;
  margin: 40px auto;
  .feature-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .check-icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background: linear-gradient(135deg, #4CAF50, #8BC34A);
      border-radius: 50%;
      margin-right: 10px;
      font-size: 12px;
    }
    
    .feature-text {
      text-align: left;
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.pricing-options {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.price-option {
  flex: 1;
  padding: 15px;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }
  
  &.selected {
    border-color: #5065F6;
    background-color: #f5f7ff;
    box-shadow: 0 5px 15px rgba(80, 101, 246, 0.15);
  }
  
  .option-label {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  
  .price {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin-bottom: 4px;
  }
  
  .billing-note {
    font-size: 12px;
    color: #888;
  }
  
  &.annual {
    border-color: #eaeaea;
    background-color: transparent;
    
    &.selected {
      border-color: #5065F6;
      background-color: #f5f7ff;
    }
  }
}

.action-area {
  margin-bottom: 15px;
  
  .upgrade-btn {
    width: 100%;
    padding: 12px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(to right, #4F5BD5, #5065F6, #7582EB);
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 10px rgba(80, 101, 246, 0.3);
    
    &:hover {
      box-shadow: 0 6px 15px rgba(80, 101, 246, 0.4);
      transform: translateY(-2px);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 5px rgba(80, 101, 246, 0.3);
    }
  }
}

.terms-section {
  text-align: center;
  font-size: 12px;
  color: #888;
  
  a {
    color: #5065F6;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

/* 支付方式选择弹窗 */
.payment-dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2002; /* 确保比主弹窗层级高 */
}

.payment-dialog-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.payment-dialog {
  position: relative;
  width: 400px;
  background-color: #38354A;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  z-index: 2003;
  animation: dialog-animation 0.25s ease-out forwards;
}

@keyframes dialog-animation {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.payment-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  h3 {
    color: white;
    font-size: 20px;
    margin: 0;
    font-weight: bold;
  }
  
  .close-button {
    position: relative;
    top: 0;
    right: 0;
    
    i {
      color: white;
    }
  }
}

/* 二维码弹窗样式 */
.qrcode-dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2004; /* 确保比支付方式弹窗层级更高 */
}

.qrcode-dialog-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.qrcode-dialog {
  position: relative;
  width: 400px;
  background-color: #38354A;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  z-index: 2005;
  animation: dialog-animation 0.25s ease-out forwards;
}

.qrcode-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  h3 {
    color: white;
    font-size: 20px;
    margin: 0;
    font-weight: bold;
  }
  
  .close-button {
    position: relative;
    top: 0;
    right: 0;
    
    i {
      color: white;
    }
  }
}

.payment-methods {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 0;

  .payment-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    font-weight: bold;

    span {
      font-size: 16px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &.wechat {
      background-color: #2DC100;
      color: white;
    }

    &.credit-card {
      background-color: #6C5CE7;
      color: white;
    }

    img {
      height: 35px;
      width: 35px;
    }

    .card-icons {
      display: flex;
      gap: 10px;
    }
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: white;

  .qrcode-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .order-number {
      color: #ddd;
    }

    img {
      border: 1px solid #fefefe;
      width: 200px;
      height: 200px;
      margin-top: 20px;
    }

    span {
      margin-top: 10px;
    }

    .price-text {
      font-size: 26px;
      font-weight: bold;
      color: red;
    }

    .qrcode-wrapper {
      position: relative;
      display: inline-block;
      margin: 20px 0;
      width: 200px;
      height: 200px;

      img {
        max-width: 100%;
        max-height: 100%;
        margin: 10px 0;
      }

      .qrcode-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 205px;
        height: 220px;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s;

        span {
          color: white;
          text-align: center;
          font-size: 14px;
          line-height: 1.5;

          i {
            font-size: 24px;
            margin-bottom: 8px;
            display: block;
          }
        }

        &:hover {
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .popup-container {
    width: 90vw;
    padding: 25px 20px;
  }
  
  .pricing-options {
    flex-direction: column;
  }
  
  .price-option {
    width: 100%;
  }
  
  .action-area .upgrade-btn {
    font-size: 14px;
    padding: 10px;
  }
  
  .payment-dialog, .qrcode-dialog {
    width: 90vw;
    max-width: 400px;
  }
}
</style>
